import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'usimweb-chip',
    template: `
    <mat-chip-listbox>
      <mat-chip
        class="selected-filter"
        *ngFor="let property of chips"
        [removable]="'true'"
        (removed)="removeProperty(property)"
      >
        {{ property.name }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    </mat-chip-listbox>
  `,
    styleUrls: ['./chip.component.scss'],
    standalone: false
})
export class ChipComponent {
  @Input() chips!: any[];

  @Output() onRemove: EventEmitter<boolean> = new EventEmitter<boolean>();

  public removeProperty(property: any) {
    this.onRemove.emit(property);
  }
}
